import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LongPostView from './LongPostView';
import { PracticeWidget } from '../Practice';
import PageContainer from '../layout/PageContainer';
import { userRequest } from '../../requestMethods';

const LongPostDetail = () => {
    const { slug } = useParams();
    const [postId, setPostId] = useState(null);

    useEffect(() => {
        if (slug) {
            // Fetch post to get the _id for PracticeWidget
            userRequest.get(`/contentLongPost/slug/${slug}`)
                .then(response => {
                    if (response.data?._id) {
                        setPostId(response.data._id);
                    }
                })
                .catch(error => {
                    console.error('Error fetching post ID:', error);
                });
        }
    }, [slug]);

    return (
        <PageContainer>
            <LongPostView slug={slug} />
            {postId && (
                <PracticeWidget 
                    contentType="ContentLongPost" 
                    contentId={postId} 
                />
            )}
        </PageContainer>
    );
};

export default LongPostDetail;
